<template>
    <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
            <h1 class="h4 mb-0">Products</h1>
        </div>
    </div>

    <div class="page-section page-section-first">
        <div class="row">

            <div v-if="canSeePriceList" @click="openPriceListPdf" class="quick-link col-md-6 mb-4">
            <div class="icon-column"><div class="icon"><div class="bi bi-tags"></div></div></div>
                <div class="text">
                    <div><strong>Price List</strong></div>
                    <div class="text-description">Download our price list</div>
                </div>
                <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
            </div>

            <div @click="openTurnaroundTimesPdf" class="quick-link col-md-6 mb-4">
                <div class="icon-column">
                    <div class="icon">
                        <i class="bi bi-clock-history"></i>
                    </div>
                </div>  
                <div class="text">
                    <div><strong>Turnaround Times</strong></div>
                    <div class="text-description">Download our product turnaround times </div>
                </div>
                <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
            </div>
        </div>  
    </div>
    
    <div class="page-section">
        <h2 class="h5 mb-3">Product Lookup</h2>
        <p class="mb-3">Use our product lookup tool to find the price and turnaround times.</p>

        <form class="bg-light p-3" novalidate @submit.prevent="submitFilter">
            <div class="row">
                <div class="col-md-7 col-xxl-7 mb-3" v-if="products.length">
                    <DropdownInput
                        ref="productDropdown"
                        label="Select Product"
                        v-model="selectedProductId"
                        :v="selectedProductId"
                        :options="products"
                        :searchable="true"
                    />
                </div>

                <div class="col-md-5 col-xxl-5 mb-3">
                    <DropdownInput
                        ref="serviceLevelDropdown"
                        label="Service Level"
                        :v="serviceLevel"
                        v-model="serviceLevel"
                        :options="serviceLevels"
                        :searchable="false" 
                        />
                </div>
            </div>

            <span class="btn btn-secondary" @click="resetForm" v-if="selectedProductId || serviceLevel">Reset</span>
        </form>
        <div class="page-section" v-if="thinking==true">
            <h2 class="h5 m-3">Thinking ...</h2>
        </div>
        <div class="page-section mt-3" v-if="product!=null">
            <hr />
            <h2 class="h5 mb-3">Product Price & Turnaround {{ product.is_stage ? '(Individual Stage)' : '' }}</h2>
            <div class="row">
                <div :class="{'col-md-6': !product.choice_price, 'col-md-4': product.choice_price }">
                    <strong>Product:</strong><br />
                    {{ product.product_name }}
                </div>
                <div class="col-md-2">
                    <strong>Price:</strong><br />
                    {{ this.$filters.formatMoney(product.price) }}{{  product.is_teeth || product.is_material ? ' * ' : ''  }}
                </div>
                <div class="col-md-2" v-if="product.choice_price!=null && product.choice_enabled == true">
                    <strong>Choice Price:</strong><br />
                    {{ this.$filters.formatMoney(product.choice_price) }}
                </div>
                <div class="col-md-2">
                    <strong>Turnaround:</strong><br />
                    {{  product.turnaround_time }} days
                </div>
                <div class="col-md-2" v-if="product.choice_price!=null && product.choice_enabled == true">
                    <strong>Choice Turnaround:</strong><br />
                    {{  product.turnaround_time_choice }} days
                </div>
            </div>

            <div class="row mt-3" v-if="product.is_teeth">
                <div class="col-xs-12 bg-light p-2 mb-3">
                    <strong>* Price may vary based on the number of teeth, please contact us for a custom quote.</strong>
                </div>
            </div>

            <div class="row mt-3" v-if="product.is_material">
                <div class="col-xs-12 bg-light p-2 mb-3">
                    <strong>* Price may vary based on the amount of material, please contact us for a custom quote.</strong>
                </div>
            </div>

            <div class="page-section mt-5" v-if="product.product_collections != undefined">
                <h2 class="h5 mb-3">Product Package</h2>
                <div v-for="collection in product.product_collections" :key="collection.label">
                    <div class="row">
                        <div :class="{'col-md-6': !product.choice_price, 'col-md-4': product.choice_price }">
                            <strong>Name:</strong><br />
                            {{ collection.label }}<br /><br />
                        </div>
                        <div class="col-md-2">
                            <strong>Price:</strong><br />
                            {{ this.$filters.formatMoney(collection.price) }}
                        </div>
                        <div class="col-md-2" v-if="collection.choice_price && product.choice_enabled == true">
                            <strong>Choice Price:</strong><br />
                            {{ this.$filters.formatMoney(collection.choice_price) }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 bg-light p-2 mb-3">
                            <strong>Includes:</strong>
                            {{ collection.included_items }}
                        </div>                      
                    </div>
                </div>
            </div>
        </div>

    </div>

    
</template>

<script>
    import api from "@/services/api";
    import base64 from "@/services/base64";
    import DropdownInput from '@/components/DropdownInput.vue';

    export default {
        data() {return {
            product: null,
            serviceLevel: '',
            products: [],
            selectedProductId: '',
            serviceLevels: [],
            thinking: false,
            search: null,
        }},
        methods: {
            openTurnaroundTimesPdf: function() {
                var pdfWindow = window.open();
                pdfWindow.document.title = "Loading...";

                api
                .get('/api/v1/turnaround-times/' + this.$store.state.currentPracticeId)
                .then((response) => {
                    var blob = base64.toBlob(response.data, 'application/pdf');
                    pdfWindow.location = URL.createObjectURL(blob);
                })
                .catch((error) => {
                    pdfWindow.close();
                    console.log('Catch turnaround times pdf error', error);
                    alert('There was an error downloading the turnaround times, please try again later.');
                });
            },
            openPriceListPdf: function () {
              var pdfWindow = window.open();
              pdfWindow.document.title = "Loading...";

              api
                .get('/api/v1/priceList', {
                  params: { practice_id: this.$store.state.currentPracticeId },
                })
                .then((response) => {
                  var blob = base64.toBlob(response.data, 'application/pdf');
                  pdfWindow.location = URL.createObjectURL(blob);
                })
                .catch((error) => {
                  pdfWindow.close();
                  console.error('Something went wrong fetching the price list', error);
                  alert('There was an error downloading the price list please try again later');
                });
            },
            resetForm: function() {
                this.$refs.productDropdown.reset();
                this.$refs.serviceLevelDropdown.reset();
                this.product = null;
            },
            fetchProducts: function() {
                var params = {
                    practice_id: this.$store.state.currentPracticeId,
                };

                api
                .get('/api/v1/productsList', { params })
                .then((response) => {
                    this.products = response.data.products.map((product) => {
                        return {
                            id: product.id,
                            label: product.name,
                        }
                    });
                })
                .catch((error) => {
                    console.log('Catch products error', error);
                    alert('There was an error fetching the products, please try again later.');
                });
            },
            fetchServiceLevels: function() {                
                this.serviceLevels = [{
                    id: 1,
                    label: 'NHS / Standard',
                }, {
                    id: 2,
                    label: 'Independent',
                }, {
                    id: 3,
                    label: 'Private',
                }]
            },
            fetchMatchingProduct: function() {
                if(this.selectedProductId && this.serviceLevel)
                {
                    var params = {
                        practice_id: this.$store.state.currentPracticeId,
                        product_id: this.selectedProductId,
                        service_level: this.serviceLevel,
                    };

                    this.thinking = true;
                    this.product = null;

                    api
                    .get('/api/v1/productLookup', { params })
                    .then((response) => {
                        console.log(response);
                        this.product = response.data;
                        this.thinking = false;
                    })
                    .catch((error) => {
                        console.log('Catch product lookup error', error);

                    });
                }
            },
          },
        computed: {
            canSeePriceList() {
                if (this.$store.state.currentPractice === null) {
                    return false;
                }
                return this.$store.state.currentPractice.limited_to_company;
            },
        },
        components: {
            DropdownInput,
        },
        mounted() {
            this.fetchProducts();
            this.fetchServiceLevels();
            console.log(this.$refs);
        },
        watch: {
            selectedProductId() {
                this.fetchMatchingProduct();
            },
            serviceLevel() {
                this.fetchMatchingProduct();
            }
        }
    }

</script>

<style scoped lang="scss">
.action
{
  padding-bottom: 20px;

  .action-link
  {
    display: flex;
    align-items: center;
  }

  .action-icon
  {
    aspect-ratio: 1/1;
    line-height: 0;
    font-size: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    width: 70px;
  }
}

.quick-link
{
  text-decoration: none;
  display: flex;
  cursor:pointer;

  .icon-column
  {
    display: flex;
    flex-direction: column;
    margin-right: $spacer;
  }

  .icon
  {
    background: $swift-lighter-grey;
    border-radius: 10px;
    aspect-ratio: 1/1;
    font-size: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 70px;
  }

  .text
  {
    flex-grow: 1;
    margin-right: $spacer;
  }

  .text-description
  {
    line-height: 1.3em;
  }

  .arrow
  {
    img
    {
      width: 30px;
      margin-top: 10px;
    }
  }

  &:hover
  {
    .icon
    {
      background: $swift-light-grey;
      transition: 0.5s;
    }
  }
}
</style>